import "./ServicesHero.css";

function ServicesHero({ eyebrow, title, text }) {
  return (
    <section className="services-hero-container fade-in-up">
      <div className="services-hero-panel hover-lift">
        {eyebrow && <span className="services-hero-eyebrow">{eyebrow}</span>}
        <h1>{title}</h1>
        <p>{text}</p>
      </div>
    </section>
  );
}

export default ServicesHero;
